"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NonEmptyList = void 0;
var Maybe_1 = require("./Maybe");
var NonEmptyListConstructor = function (list) { return list; };
exports.NonEmptyList = Object.assign(NonEmptyListConstructor, {
    fromArray: function (source) {
        return exports.NonEmptyList.isNonEmpty(source) ? Maybe_1.Just(source) : Maybe_1.Nothing;
    },
    unsafeCoerce: function (source) {
        return exports.NonEmptyList.isNonEmpty(source)
            ? source
            : (function () {
                throw new Error('NonEmptyList#unsafeCoerce passed an empty array');
            })();
    },
    fromTuple: function (source) {
        return exports.NonEmptyList(source.toArray());
    },
    head: function (list) { return list[0]; },
    last: function (list) { return list[list.length - 1]; },
    isNonEmpty: function (list) { return list.length > 0; },
    tail: function (list) { return list.slice(1); }
});
